import { useState } from 'react';
import { createComprador } from '../../services/compradorService';
import { IComprador } from '../../interfaces/comprador.interface';

const useCreateComprador = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = async (comprador: IComprador) => {
    setLoading(true);
    try {
      const newComprador = await createComprador(comprador);
      return newComprador;
    } catch (err) {
      setError('Falha ao criar comprador' + err);
    } finally {
      setLoading(false);
    }
  };

  return { create, loading, error };
};

export default useCreateComprador;
